module.exports = __webpack_public_path__ + "static/media/abogados (2).4441b218.jpg";